module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('PageHeader'), _vm._v(" "), _c('div', {
    class: _vm.headerClass
  }, [_c('div', {
    staticClass: "kuiu-anchorage-image-container"
  }, [(_vm.getSubscription === 'specialsauce' && !_vm.isSuccessPage) ? _c('img', {
    staticClass: "special-sauce-image",
    attrs: {
      "src": require("../assets/images/goodlife_logo.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getSubscription === 'kuiuanchorage' && !_vm.isSuccessPage) ? _c('img', {
    staticClass: "kuiu-anchorage-image",
    attrs: {
      "src": require("../assets/images/anchorage_logo.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.pageTitleText))])]), _vm._v(" "), (_vm.pageTitleSubtext && !_vm.isSuccessPage) ? _c('div', {
    class: _vm.subtextClass
  }, [_vm._v(_vm._s(_vm.pageTitleSubtext))]) : _vm._e(), _vm._v(" "), (_vm.getSubscription === 'kuiuanchorage' && _vm.isSuccessPage) ? _c('div', {
    staticClass: "success-page-subtext"
  }, [_vm._v("DOWNLOAD THE APP")]) : _vm._e()]), _vm._v(" "), (_vm.busy) ? _c('h2', [_vm._v("loading...")]) : _vm._e(), _vm._v(" "), _c(_vm.currentView, {
    tag: "component",
    on: {
      "success": _vm.setView,
      "login": _vm.routeLogin,
      "register": _vm.routeZipAndAge
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76aa00d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HomeQuick.vue
// module id = 397
// module chunks = 1